module.exports = __webpack_public_path__ + "static/media/private-user-pin.1df8394d.svg";